<template>
  <div class="mls-hq">
    <div class="mls-hq__card">
      <div class="mls-hq__hero">
        <div class="mls-hq__hero-visit">
          <h2>Visit the</h2>
        </div>
        <div class="mls-hq__hero-heading">
          <h2>
            MLS HQ:
            <br />
            Inside Experience
          </h2>
        </div>
      </div>

      <div class="mls-hq__details">
        <div class="mls-hq__crest">
          <img src="/assets/mls/mls-logo.png" alt="Major League Soccer" width="181" height="193" />
        </div>

        <div class="mls-hq__event">
          <p class="mls-hq__when">
            <time datetime="2026-10-15T17:30:00-04:00">
              Thurs, Oct 15
              <br />
              5:30pm
            </time>
          </p>
          <address class="mls-hq__address">
            2 Penn Plaza
            <span class="mls-hq__address-city">New York, NY 10121</span>
          </address>
        </div>

        <div class="mls-hq__brand">
          <img :src="`${useCdnUrl()}/assets/logos/zen-2023-header.svg`" alt="Zenapptic.ai" />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@font-face {
  font-display: swap;
  font-family: 'MLS Tifo Headline';
  font-style: normal;
  font-weight: 400;
  src: url('/assets/fonts/mls-tifo/MLSTifoHeadline-Regular.otf') format('opentype');
}

@font-face {
  font-display: swap;
  font-family: 'MLS Tifo Headline';
  font-style: normal;
  font-weight: 500;
  src: url('/assets/fonts/mls-tifo/MLSTifoHeadline-Medium.otf') format('opentype');
}

@font-face {
  font-display: swap;
  font-family: 'MLS Tifo Headline';
  font-style: normal;
  font-weight: 700;
  src: url('/assets/fonts/mls-tifo/MLSTifoHeadline-Bold.otf') format('opentype');
}

.mls-hq {
  --mls-header-height: 86px;

  background: #000;
  display: grid;
  font-family: 'MLS Tifo Headline', 'pragmatica', sans-serif;
  min-height: calc(100svh - var(--mls-header-height));
  place-items: center;

  &__card {
    aspect-ratio: 1;
    background: #fff;
    container-type: inline-size;
    margin: 0 auto;
    max-width: 1254px;
    overflow: hidden;
    width: min(100%, calc(100svh - var(--mls-header-height)));
  }

  &__hero {
    align-items: start;
    background-image: url('/assets/mls-tour/mls-hq-interior.jpg');
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    display: grid;
    grid-template-columns: max-content 1fr;
    height: 74.8cqw;

    position: relative;
  }

  &__hero-visit,
  &__hero-heading {
    z-index: 1;

    h2 {
      font-size: 5.85cqw;
      font-weight: 700;
      letter-spacing: -0.005em;
      line-height: 1;
      margin: 0;
      text-transform: uppercase;
    }
  }

  &__hero-visit {
    color: #000;
    padding: 5.75cqh 1.25cqw 0 2.5cqw;
    position: relative;
    white-space: nowrap;
    width: max-content;

    &::before {
      background: #fff;
      bottom: 0.4cqw;
      content: '';
      left: 0;
      position: absolute;
      right: 0;
      top: 0;
    }

    h2 {
      font-size: 4cqw;
      font-weight: 500;
      line-height: 0.86;
      position: relative;
    }
  }

  &__hero-heading {
    box-shadow: 0 -3.8cqw 0 #000;
    color: #fff;
    margin-top: 3.8cqw;
    min-width: 0;
    padding: 0;
    position: relative;
    white-space: nowrap;

    &::before {
      background: #06235c;
      bottom: 0.45cqw;
      content: '';
      left: 0.2cqw;
      position: absolute;
      right: 0;
      top: 0;
    }

    &::after {
      background: #000;
      bottom: 0.45cqw;
      content: '';
      left: 0;
      position: absolute;
      top: 0;
      width: 0.2cqw;
    }

    h2 {
      font-weight: 700;
      line-height: 1.13;
      margin-bottom: -4px;
      margin-left: -4px;
      position: relative;
      z-index: 1;
    }
  }

  &__details {
    align-items: center;
    background: #ef2118;
    color: #fff;
    display: grid;
    gap: 4cqw;
    grid-template-columns: 18cqw 1fr;
    height: 25.2cqw;
    padding: 2.3cqw 3.5cqw;
    position: relative;
  }

  &__crest {
    align-self: stretch;
    display: grid;
    place-items: center;

    img {
      display: block;
      max-height: 18cqw;
      object-fit: contain;
      width: 16cqw;
    }
  }

  &__event {
    align-self: center;
    padding-bottom: 1cqw;
  }

  &__when,
  &__address {
    font-size: 4.1cqw;
    font-style: normal;
    font-weight: 700;
    letter-spacing: 0.005em;
    line-height: 1.03;
    margin: 0;
    text-transform: uppercase;
  }

  &__when {
    font-size: 3cqw;
    font-weight: 500;
    margin-bottom: 0.8cqw;
  }

  &__address-city {
    display: block;
    font-size: 3.1cqw;
  }

  &__brand {
    bottom: 1.8cqw;
    position: absolute;
    right: 1.8cqw;

    img {
      display: block;
      height: auto;
      width: 18cqw;
    }
  }

  @media (max-width: 940px) {
    --mls-header-height: 60px;
  }

  @media (max-width: 767px) {
    min-height: 0;
  }
}
</style>
